import React, { memo } from 'react';
import { Users, Plus, Mail, Crown, UserPlus } from 'lucide-react';
import { EmptyState } from './EmptyState';
type FamilyMember = {
  id: number;
  name: string;
  role: 'admin' | 'member';
  avatar: string;
  email: string;
  storiesCount: number;
};
const familyMembers: FamilyMember[] = [{
  id: 1,
  name: 'Daniel',
  role: 'admin',
  avatar: 'D',
  email: 'daniel@example.com',
  storiesCount: 5
}];
export function FamilyPage() {
  return <div className="flex-1 bg-gray-100 min-h-screen" data-id="element-687">
      <div className="px-8 py-6" data-id="element-688">
        {/* Header */}
        <div className="flex items-center justify-between mb-6" data-id="element-689">
          <div className="flex items-center gap-3" data-id="element-690">
            <div className="p-2 bg-blue-100 rounded-lg" data-id="element-691">
              <Users className="w-6 h-6 text-blue-600" data-id="element-692" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-693">Family</h1>
          </div>

          <button className="flex items-center gap-2 px-6 py-3 bg-[#4ade80] text-white font-medium rounded-xl hover:bg-[#22c55e] transition-colors" data-id="element-694">
            <UserPlus className="w-5 h-5" data-id="element-695" />
            Invite Family Member
          </button>
        </div>

        <p className="text-gray-600 mb-8" data-id="element-696">
          Collaborate with family members to preserve your shared stories and
          memories.
        </p>

        {/* Family Members */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-8" data-id="element-697">
          <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-698">
            Family Members ({familyMembers.length})
          </h2>

          <div className="space-y-4" data-id="element-699">
            {familyMembers.map(member => <div key={member.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-xl hover:border-gray-300 transition-colors" data-id="element-700">
                <div className="flex items-center gap-4" data-id="element-701">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center" data-id="element-702">
                    <span className="text-green-600 font-semibold text-lg" data-id="element-703">
                      {member.avatar}
                    </span>
                  </div>
                  <div data-id="element-704">
                    <div className="flex items-center gap-2" data-id="element-705">
                      <span className="font-semibold text-gray-900" data-id="element-706">
                        {member.name}
                      </span>
                      {member.role === 'admin' && <span className="flex items-center gap-1 px-2 py-0.5 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-707">
                          <Crown className="w-3 h-3" data-id="element-708" />
                          Admin
                        </span>}
                    </div>
                    <div className="flex items-center gap-2 text-sm text-gray-600" data-id="element-709">
                      <Mail className="w-3.5 h-3.5" data-id="element-710" />
                      {member.email}
                    </div>
                  </div>
                </div>
                <div className="text-right" data-id="element-711">
                  <div className="text-sm text-gray-600" data-id="element-712">Stories</div>
                  <div className="text-lg font-semibold text-gray-900" data-id="element-713">
                    {member.storiesCount}
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Pending Invitations */}
        <div className="bg-white rounded-2xl shadow-sm p-6" data-id="element-714">
          <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-715">
            Pending Invitations
          </h2>
          <EmptyState icon={Mail} title="No pending invitations" description="Invite family members to start collaborating on your family stories." actionLabel="Send Invitation" onAction={() => {}} data-id="element-716" />
        </div>
      </div>
    </div>;
}